import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { initTempDashboard } from '@store/noc/tempDashboard/actions';
import tempDashboardSelector from '@store/noc/tempDashboard/selectors';
import nocTempDashboardSelector from '@store/noc/selectors';
import { DASHBOARD_TYPE } from '@utils/constants';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { filterIndicesSelector } from '@store/comparison/selectors';
import NocComponent from './NocComponent';
import tempDashboard from '../common/tempDashboard';

const tempDashboardDetailsSelector = createSelector(
  nocTempDashboardSelector,
  tempDashboardSelector,
  filterContainerSelector,
  filterIndicesSelector,
  (dashboard, tempDashboardStore, filterContainer, filterIndices) => ({
    dashboard,
    dashboardType: DASHBOARD_TYPE.NOC,
    isFetching: tempDashboardStore.isFetching,
    filterContainer,
    filterIndices,
  }),
);

const TempDashboardNoc = compose(
  connect(tempDashboardDetailsSelector, { init: initTempDashboard }),
  tempDashboard,
)(NocComponent);

export default TempDashboardNoc;
